import { UrlBase } from '@/config/base.config'
import store from '../store/index'
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

export class EntityService {
  axiosObj: AxiosInstance

  constructor () {
    this.axiosObj = axios.create({
      baseURL: UrlBase,
      timeout: 300000
    })
  }

  async getList (entity: string, params?: {}) {
    try {
      const config: AxiosRequestConfig = {
        headers: { Authorization: `Bearer ${store.state.token}` },
        params: params,
        timeout: 300000
      }
      const list = await this.axiosObj.get(entity, config)
      return list.data
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        throw new Error(e.response.data.message)
      } else {
        throw new Error(e)
      }
    }
  }

  async getOne (entity: string, id: string) {
    try {
      const config: AxiosRequestConfig = {
        headers: { Authorization: `Bearer ${store.state.token}` }
      }
      const entityObj = await this.axiosObj.get(`${entity}/${id}`, config)
      return entityObj.data
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        throw new Error(e.response.data.message)
      } else {
        throw new Error(e)
      }
    }
  }

  async createEntity (entity: string, form: object) {
    try {
      const config: AxiosRequestConfig = {
        headers: { Authorization: `Bearer ${store.state.token}` }
      }
      const response = await this.axiosObj.post(entity, form, config)
      return response.data
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        throw new Error(e.response.data.message)
      } else {
        throw new Error(e)
      }
    }
  }

  async delete (entity: string, id: string) {
    try {
      const config: AxiosRequestConfig = {
        headers: { Authorization: `Bearer ${store.state.token}` }
      }
      const entityObj = await this.axiosObj.delete(`${entity}/${id}`, config)
      return entityObj.data
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        throw new Error(e.response.data.message)
      } else {
        throw new Error(e)
      }
    }
  }

  async updateEntity (id: number, entity: string, form: object) {
    try {
      const config: AxiosRequestConfig = {
        headers: { Authorization: `Bearer ${store.state.token}` }
      }
      const response = await this.axiosObj.put(`${entity}/${id}`, form, config)
      return response.data
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        throw new Error(e.response.data.message)
      } else {
        throw new Error(e)
      }
    }
  }

  async uploadFile (entity: string, url: string, file: Blob) {
    try {
      const config: AxiosRequestConfig = {
        headers: { Authorization: `Bearer ${store.state.token}` },
        timeout: 60 * 30 * 1000
      }
      const form = new FormData()
      form.append('file', file)
      const response = await this.axiosObj.post(`${entity}/${url}`, form, config)
      return response.data
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        throw new Error(e.response.data.message)
      } else {
        throw new Error(e)
      }
    }
  }

  async uploadFileRoot (url: string, file: Blob) {
    try {
      const config: AxiosRequestConfig = {
        headers: { Authorization: `Bearer ${store.state.token}` },
        timeout: 60 * 30 * 1000
      }
      const form = new FormData()
      form.append('file', file)
      const response = await this.axiosObj.post(url, form, config)
      return response.data
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        throw new Error(e.response.data.message)
      } else {
        throw new Error(e)
      }
    }
  }

  async downloadFile (url: string, form?: object | null) {
    try {
      const config: AxiosRequestConfig = {
        headers: { Authorization: `Bearer ${store.state.token}` },
        responseType: 'blob',
        timeout: 60 * 30 * 1000
      }
      const response = await this.axiosObj.post(url, form, config)
      return { data: response.data as Blob, headers: response.headers }
    } catch (e) {
      // Con responseType 'blob' el cuerpo del error también llega como Blob
      if (e.response && e.response.data instanceof Blob) {
        let message: string | string[] = ''
        try {
          message = JSON.parse(await e.response.data.text()).message
        } catch (parseError) {}
        if (Array.isArray(message)) message = message.join('\n')
        if (message) throw new Error(message)
      }
      throw new Error(e)
    }
  }

  async makeAction (entity: string, action: string, form?: object | null) {
    try {
      const config: AxiosRequestConfig = {
        headers: { Authorization: `Bearer ${store.state.token}` }
      }
      const response = await this.axiosObj.post(`${entity}/${action}`, form, config)
      return response.data
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        throw new Error(e.response.data.message)
      } else {
        throw new Error(e)
      }
    }
  }

  async makeEntityAction (entity: string, id: number, action: string, form?: object | null) {
    try {
      const config: AxiosRequestConfig = {
        headers: { Authorization: `Bearer ${store.state.token}` }
      }
      const response = await this.axiosObj.post(`${entity}/${id}/${action}`, form, config)
      return response.data
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        throw new Error(e.response.data.message)
      } else {
        throw new Error(e)
      }
    }
  }
}
